import { LeftOutlined } from '@ant-design/icons';
import { Col, Divider, Row } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import failIcon from '~/assets/icons/fail-icon.png';
import Card from '~/components/Card/Card';
import LanguageSelect from '~/components/forms/LanguageSelect/LanguageSelect';
import Image from '~/components/Image/Image';
import LegacyWrapper from '~/components/Legacy/LegacyWrapper';
import { Link, Text, Title } from '~/components/Typo/Typo';
import { GetPaymentResponse } from '~/entities/responses/getPaymentResponse';
import { GetTransactionResponse } from '~/entities/responses/getTransactionResponse';
import { CryptoService } from '~/services/CryptoService';
import { FontWeight } from '~/theme/constants';
import { DATE_FORMAT, formatDate } from '~/utils/date';
import { formatNumber } from '~/utils/number';

import './FailPage.scss';

const FailPage: React.FC = () => {
  const { t, i18n } = useTranslation();

  const [transactionResponse, setTransactionResponse] = useState<GetTransactionResponse>();
  const [transaction, setTransaction] = useState<GetPaymentResponse>();

  const handleGetTransaction = useCallback(() => {
    const crypto = new CryptoService();
    crypto.setSecretKey(process.env.REACT_APP_APPLI_SECKEY ?? '');
    const decryptData = crypto.decryptData(
      localStorage.getItem('transactionDetails') as string,
    ) as GetTransactionResponse;

    // const getTrans = JSON.parse(localStorage.getItem('transactionDetails') as string);
    setTransactionResponse(decryptData);
  }, []);

  const handleGetTransactionsInfos = useCallback(() => {
    // const getData = JSON.parse(localStorage.getItem('data') as string);

    const crypto = new CryptoService();
    crypto.setSecretKey(process.env.REACT_APP_APPLI_SECKEY ?? '');
    const decryptData = crypto.decryptData(localStorage.getItem('data') as string) as GetPaymentResponse;
    setTransaction(decryptData);
  }, []);

  const handleRedirect = useCallback((url: string) => {
    window.location.replace(url);
    clearData();
  }, []);

  const clearData = useCallback(() => {
    localStorage.removeItem('data');
    localStorage.removeItem('transactionDetails');
  }, []);

  useEffect(() => {
    handleGetTransaction();
    handleGetTransactionsInfos();
    window.addEventListener('beforeunload', clearData);
    return () => {
      window.removeEventListener('beforeunload', clearData);
    };
  }, []);
  return (
    <div className="fail-page">
      <Row justify="center">
        <Col lg={8} sm={24} md={12} xs={24}>
          <Card slightlyRounded className="failPage-body-content">
            <div className="header">
              <Row justify="space-between">
                <div className="left-side-header">
                  <div className="merchant-wrapper">
                    <Title className="merchant-label" level={4} weight={FontWeight.LIGHT}>
                      {transactionResponse?.data?.application?.merchant?.name}
                    </Title>
                  </div>
                  <div className="amount-wrapper">
                    <Title className="amount-label" level={4} weight={FontWeight.SEMIBOLD}>
                      {`${formatNumber(
                        transactionResponse?.data?.transaction.total_amount ?? 0,
                        i18n.language ?? 'fr',
                      )} ${transactionResponse?.data?.transaction.currency}`}
                    </Title>
                  </div>
                </div>
                <div className="right-side-header">
                  <LanguageSelect className="language-fail-page" />
                </div>
              </Row>
            </div>
            <Divider />
            <div className="content">
              <Row justify="center">
                <Image className="fail-icon" image={failIcon} />
              </Row>

              <p className="tac">{t('failPage:yourPaymentFailed')}</p>
              <Card className="transaction-details-wrapper">
                <div>
                  <Text weight={FontWeight.BOLD}>{t('successPage:merchant')}: </Text>
                  <Text>{transactionResponse?.data?.application?.merchant?.name}</Text>
                </div>
                <div>
                  <Text weight={FontWeight.BOLD}>{t('successPage:amountLocalCurrency')}: </Text>
                  <Text>
                    {`${formatNumber(
                      transactionResponse?.data?.transaction.local_total_amount ?? 0,
                      i18n.language ?? 'fr',
                    )} ${transactionResponse?.data?.transaction.local_currency}`}
                  </Text>
                </div>
                <div>
                  <Text weight={FontWeight.BOLD}>{t('successPage:descriptionOfPurchase')}: </Text>
                  <Text>{transactionResponse?.data?.transaction.description}</Text>
                </div>
                <div>
                  <Text weight={FontWeight.BOLD}>{t('successPage:operatorId')}: </Text>
                  <Text>{transactionResponse?.data?.transaction.operator_id ?? ''}</Text>
                </div>
                <div>
                  <Text weight={FontWeight.BOLD}>{t('successPage:transactionId')}: </Text>
                  <Text>{transactionResponse?.data?.transaction.transaction_id ?? ''}</Text>
                </div>
                <div>
                  <Text weight={FontWeight.BOLD}>{'Date'}: </Text>
                  <Text>{`${formatDate(
                    transactionResponse?.data?.transaction.payment_date as Date,
                    DATE_FORMAT.DATE_TIME,
                  )} (${transactionResponse?.data?.transaction.payment_date_offset ?? ''})`}</Text>
                </div>
                {/* <div>
                  <Text weight={FontWeight.BOLD}>{'Reason'}: </Text>
                  <Text>{transactionResponse?.data?.transaction.description}</Text>
                </div> */}
              </Card>
              <Row justify="center">
                <Link className="back-button" onClick={() => handleRedirect(transaction?.data?.returnUrl ?? '')}>
                  <LeftOutlined className="back-icon" />
                  <Text>{t('failPage:backToTheSite')}:</Text>
                </Link>
              </Row>
            </div>
          </Card>
        </Col>
      </Row>
      <div className="fail-page-footer">
        <Row justify="center">
          <LegacyWrapper label={t('home:footer:securedBy')} />
        </Row>
      </div>
    </div>
  );
};

export default FailPage;
